export default __webpack_public_path__ + "static/media/pivotMaximise.a684fb2a.svg";